import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

type GetCourseLearningOutcomesParams = {
  courseId: number;
};

const { useGet: useCourseLearningOutcomes } = getCRUDHooks({
  entityName: 'courseLearningOutcomes',
  get: ({ courseId }: GetCourseLearningOutcomesParams) =>
    clientApi.getOCClient().helpers.learningContent.courses.getLearningOutcomes(courseId),
});

export default useCourseLearningOutcomes;
